export type AutosaveBlock = "locked" | "incomplete" | "reason" | null;

export interface AutosaveState {
  closed: boolean;
  invoiced: boolean;
  hasOrder: boolean;
  hasLnwNumber: boolean;
  incompleteCount: number;
  invalidHours: boolean;
  approvedChanged: boolean;
  reasonLength: number;
}

/** Decides whether a LNW may be saved automatically; returns the reason it may not. */
export const getAutosaveBlock = (s: AutosaveState): AutosaveBlock => {
  if (s.closed || s.invoiced) return "locked";
  if (!s.hasOrder || !s.hasLnwNumber || s.incompleteCount > 0 || s.invalidHours) return "incomplete";
  if (s.approvedChanged && s.reasonLength < 5) return "reason";
  return null;
};
